var t="\n    writeOutput();\n}\n";export{t as default};
